// Month or quarter picker shared by the distributor-target screens.
// periodStart is always 'YYYY-MM' (for a quarter: its first month, Jan/Apr/Jul/Oct).
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const MONTHS = ["January", "February", "March", "April", "May", "June", "July",
  "August", "September", "October", "November", "December"];
const SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function nowIst() { return new Date(Date.now() + 5.5 * 3600 * 1000); }
export function currentMonthStart() { return nowIst().toISOString().slice(0, 7); }
export function currentQuarterStart() {
  const d = nowIst(); const m = d.getUTCMonth() + 1;
  return `${d.getUTCFullYear()}-${String(m - ((m - 1) % 3)).padStart(2, "0")}`;
}
export function periodLabel(type, start) {
  const y = Number(start.slice(0, 4)), m = Number(start.slice(5));
  return type === "month" ? `${MONTHS[m - 1]} ${y}` : `${SHORT[m - 1]}–${SHORT[m + 1]} ${y}`;
}

export default function PeriodPicker({ periodType, periodStart, onChange, testid = "period" }) {
  const thisYear = nowIst().getUTCFullYear();
  const years = [thisYear - 2, thisYear - 1, thisYear, thisYear + 1];
  const y = periodStart.slice(0, 4), m = periodStart.slice(5);
  const setType = (t) => onChange({ periodType: t, periodStart: t === "month" ? currentMonthStart() : currentQuarterStart() });
  const quarterOptions = years.flatMap((yy) => ["01", "04", "07", "10"].map((mm) => `${yy}-${mm}`));
  return (
    <div className="flex flex-wrap items-end gap-2" data-testid={`${testid}-picker`}>
      <div className="inline-flex rounded-lg border border-neutral-200 overflow-hidden">
        {[["month", "Monthly"], ["quarter", "Quarterly"]].map(([t, label]) => (
          <button key={t} type="button" onClick={() => setType(t)} data-testid={`${testid}-type-${t}`}
                  className={"px-3 h-9 text-sm font-medium " + (periodType === t ? "bg-[#6D2C91] text-white" : "bg-white text-neutral-700")}>
            {label}
          </button>
        ))}
      </div>
      {periodType === "month" ? (
        <>
          <Select value={m} onValueChange={(v) => onChange({ periodType, periodStart: `${y}-${v}` })}>
            <SelectTrigger className="w-[130px] h-9" data-testid={`${testid}-month`}><SelectValue /></SelectTrigger>
            <SelectContent>
              {MONTHS.map((name, i) => <SelectItem key={name} value={String(i + 1).padStart(2, "0")}>{name}</SelectItem>)}
            </SelectContent>
          </Select>
          <Select value={y} onValueChange={(v) => onChange({ periodType, periodStart: `${v}-${m}` })}>
            <SelectTrigger className="w-[90px] h-9" data-testid={`${testid}-year`}><SelectValue /></SelectTrigger>
            <SelectContent>{years.map((yy) => <SelectItem key={yy} value={String(yy)}>{yy}</SelectItem>)}</SelectContent>
          </Select>
        </>
      ) : (
        <Select value={periodStart} onValueChange={(v) => onChange({ periodType, periodStart: v })}>
          <SelectTrigger className="w-[190px] h-9" data-testid={`${testid}-quarter`}><SelectValue /></SelectTrigger>
          <SelectContent>
            {quarterOptions.map((q) => <SelectItem key={q} value={q}>{periodLabel("quarter", q)}</SelectItem>)}
          </SelectContent>
        </Select>
      )}
      <Button type="button" variant="ghost" size="sm" className="h-9 text-xs text-[#6D2C91]"
              onClick={() => setType(periodType)} data-testid={`${testid}-current`}>
        This {periodType === "month" ? "month" : "quarter"}
      </Button>
    </div>
  );
}
